var WorkTypeEditModal = (function (base) {
  __extends(WorkTypeEditModal, base);


  function WorkTypeEditModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };


  WorkTypeEditModal.prototype.activate = function (workTypeId) {
    const self = this;
    const isNew = !workTypeId;
    const url = isNew ? `api/workTypes/add` : `api/workTypes/${workTypeId}/edit`;

    this.loadContent(url)
      .then($modal => {

        var $form = $('form', $modal);
        FormHelper.init($form, isNew ? 'PUT' : 'POST', 'api/workTypes');

        $('.date', $modal).datepicker({
          language: 'ru',
          format: 'dd-mm-yyyy',
          todayHighlight: true,
          toggleActive: true,
          autoclose: true
        });

        $modal

          //Кнопка `Сохранить`
          .on('click', '[js=save]', function () {
            $modal.busy();
            $form.send()
              .then(() => self.close({ ok: true }))
              .catch(() => $modal.busy(false));
          })

          // Добавление расценки в список расценок вида работ
          .on('click', '#add-quotation', function () {
            self.apiClient.post(workTypeId ? `api/workTypes/${workTypeId}/edit/addQuotation` : `api/workTypes/add/addQuotation`, {
              DateCreate: $('#DateCreate', $modal).val(),
              Code: $('#Code', $modal).val(),
              Unit: $('#Unit', $modal).val(),
              QValue1: $('#QValue1', $modal).val(),
              QValue2: $('#QValue2', $modal).val(),
              DateCreateQuotation: $('#DateCreateQuotation', $modal).val(),
              Name: $('#Name.edit-modal-control', $modal).val(),
            })
            .then(result => {
              if (result && !result.error) {
                // Генерация новой таблицы
                var $table = $('[js=quotationsTable] tbody');
                const $inputChell = '<tr js="inputChell">' + $('[js=inputChell]').html() + '</tr>';
                var tableHtml = '';
                $.each(result, (idx, quotation) => {
                  var dateFrom = (new Date(Number(quotation.DateFrom.replace('/Date(', '').replace(')/', ''))))
                    .toLocaleDateString("ru-RU");
                  tableHtml += `<tr><td>${quotation.Value1}</td><td>${quotation.Value2}</td><td>${dateFrom}` +
                    `<a class="btn btn-default pull-right no-borders del-quotation" data-id="${quotation.Id}" data-qv1="${quotation.Value1}" data-qv2="${quotation.Value2}" data-qdate="${dateFrom.replace('.', '/').replace('.', '/')} 00:00:00"><i class="fa fa-minus"></i></a>` +
                    `</td></tr>`;
                });

                $table.html(tableHtml + $inputChell);
                
              } else if (result.error) {
                // Вывод сообщений валидации
                $.each($('.field-validation-valid.text-danger', $modal),
                  function (idx, obj) {
                    if ($(obj).data('valmsgFor') === result.error.field) {
                      $(obj).text(result.error.text);
                    }
                    $('#' + result.error.field)
                      .on('change',
                        function () {
                          $(obj).text('');
                        });
                  });
              }

              $('.date', $modal).datepicker({
                language: 'ru',
                format: 'dd-mm-yyyy',
                todayHighlight: true,
                toggleActive: true,
                autoclose: true
              });
            });
          })

          // Добавление расценки из списка расценок вида работ
          .on('click', '.del-quotation', function () {
            var $delBtn = $(this);
            self.apiClient.post(workTypeId ? `api/workTypes/${workTypeId}/edit/deleteQuotation` : `api/workTypes/add/deleteQuotation`, {
              DateCreate: $('#DateCreate', $modal).val(),
              Code: $('#Code', $modal).val(),
              Unit: $('#Unit', $modal).val(),
              qId: $delBtn.data('id'),
              qVal: $delBtn.data('qv1'),
              qVal2: $delBtn.data('qv2'),
              qDate: $delBtn.data('qdate'),
              Name: $('#Name.edit-modal-control').val(),
            })
            .then(function (result) {
              if (result) {
                $delBtn.closest('tr').remove();
              }
            });
          });
      });
  };


  return WorkTypeEditModal;
}(BaseModal));
